<script setup>
// T-83 fase 2 (ata 06/08): o agente pode escrever uma mensagem para o torcedor no
// encerramento. É OPCIONAL e fica atrás de "Encerrar com mensagem" no dropdown — o
// Resolver direto segue com um clique, porque o clube pediu o MÍNIMO de ação manual.
// O texto vai em custom_attributes no mesmo request atômico do resolve (padrão T-13),
// e o backend (Fandata::Encerramento) consome no envio do e-mail.
import { ref, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['submit']);

const { t } = useI18n();
const dialogRef = ref(null);
const textareaRef = ref(null);
const mensagem = ref('');
const temEmail = ref(true);

const open = ({ contatoTemEmail } = {}) => {
  mensagem.value = '';
  temEmail.value = Boolean(contatoTemEmail);
  dialogRef.value?.open();
  nextTick(() => textareaRef.value?.focus());
};

const confirmar = () => {
  emit('submit', mensagem.value.trim());
  dialogRef.value?.close();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('CONVERSATION.ENCERRAMENTO.TITULO')"
    :confirm-button-label="t('CONVERSATION.ENCERRAMENTO.CONFIRMAR')"
    @confirm="confirmar"
  >
    <div class="flex flex-col gap-2">
      <!-- Sem e-mail não há para onde enviar: melhor avisar do que deixar o agente
           escrever um texto que ninguém receberia (webchat anônimo, WhatsApp sem e-mail). -->
      <p v-if="!temEmail" class="text-sm text-n-slate-11">
        {{ t('CONVERSATION.ENCERRAMENTO.SEM_EMAIL') }}
      </p>
      <template v-else>
        <label
          class="text-sm font-medium text-n-slate-12"
          for="fandata-encerramento-msg"
        >
          {{ t('CONVERSATION.ENCERRAMENTO.LABEL') }}
        </label>
        <textarea
          id="fandata-encerramento-msg"
          ref="textareaRef"
          v-model="mensagem"
          rows="4"
          class="w-full px-3 py-2 text-sm border rounded-lg bg-n-alpha-2 border-n-weak text-n-slate-12"
          :placeholder="t('CONVERSATION.ENCERRAMENTO.PLACEHOLDER')"
        />
        <p class="text-xs text-n-slate-10">
          {{ t('CONVERSATION.ENCERRAMENTO.AJUDA') }}
        </p>
      </template>
    </div>
  </Dialog>
</template>
